import { render, staticRenderFns } from "./AddQuery.vue?vue&type=template&id=64f78d35&scoped=true"
import script from "./AddQuery.vue?vue&type=script&lang=js"
export * from "./AddQuery.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64f78d35",
  null
  
)

export default component.exports